<template>
  <div class="ws-state-label">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>